const clientIdDevelopment = '1088869909332-runqepkkffh1i66h365v59gp338m3fhb.apps.googleusercontent.com';
const clientIdProduction = '1088869909332-runqepkkffh1i66h365v59gp338m3fhb.apps.googleusercontent.com';
const clientIdLocal = clientIdDevelopment;

const scope = 'https://www.googleapis.com/auth/business.manage https://www.googleapis.com/auth/plus.business.manage';

const redirectUriLogin = `https://${window.location.host}/login`;
const redirectUriUnit = `https://${window.location.host}/unit/authentication`;

const clientIds = {
  'localhost:8080': clientIdLocal,
  'localhost:4200': clientIdDevelopment,
  'backoffice.sabin.com.br': clientIdProduction,
  'backofficedev.cloudsabin.com': clientIdDevelopment,
  'backoffice-staging.cloudsabin.com': clientIdDevelopment
};

function getClientID() {
  var clientId = clientIds[window.location.host];
  if (clientId === undefined) {
    console.info(`Not found environment key for host: ${window.location.host}\n, using developer clientID`)
    clientId = clientIdDevelopment;
  }
  return clientId;
}

const urls = {
  'clientId': getClientID(),
  'redirectUri': redirectUriUnit,
  'redirectUriGoogle': redirectUriLogin,
  scope
};

export default urls;



// WEBPACK FOOTER //
// ./client/app/config/constantsGMB.js